import React from 'react'
import {
  ModelViewerCanvas,
  useViewerModel,
  useViewerZoom,
  useViewerRotation,
  useViewerAutoRotate,
  useViewerReset
} from '../model-viewer'
import {
  Interface,
  Instructions,
  useShowInfo,
  useContainerStyles
} from '../ui'
import { getDefaultZoom } from '../../shared/utils'
import { models } from './config/models'

function ModelViewerInstructions(props) {
  return (
    <Instructions
      description="This viewer lets you take a closer look at the fossil"
      steps={[
        'Choose one of the trilobites from the selection menu above',
        'Press on the fossil and move your finger to adjust the rotation',
        'Use the zoom slider on the right to zoom in and out'
      ]}
    />
  )
}

function TrilobiteViewerApp({ ...props }) {
  // current model
  const [active, setActiveModel] = useViewerModel(models[0])

  // zoom level for current model
  const [zoom, setZoom] = useViewerZoom(
    getDefaultZoom(models[0].zoomBounds)
  )

  // rotation for current model
  const [rotation, setRotation] = useViewerRotation()

  // auto rotate setting
  const [autoRotate, toggleRotate] = useViewerAutoRotate()

  // boolean toggle for show info
  const [showInfo, toggleInfo] = useShowInfo(true)

  // function to reset the current model
  const reset = useViewerReset()

  // handler function to update rotation based on model events
  const handleRotate = (r, interrupt = true) => {
    setRotation(r)
    interrupt && autoRotate && toggleRotate()
  }

  const handleSetModel = (e) => {
    const id = e.target.value
    const model = models.find((m) => m.id === id)
    setActiveModel(model)
  }

  const classes = useContainerStyles({
    shifted: showInfo
  })

  return active ? (
    <div className="app" {...props}>
      <ModelViewerCanvas
        className={classes.root}
        model={active}
        enableDrag={true}
        enableWheel={true}
        zoom={zoom}
        rotation={rotation}
        autoRotate={autoRotate}
        setRotation={handleRotate}
        setZoom={setZoom}
      />
      <Interface
        items={models}
        itemTitle="Current Fossil"
        activeItem={active}
        autoRotate={autoRotate}
        showInfo={showInfo}
        zoom={zoom}
        HelpComponent={<ModelViewerInstructions />}
        onReset={reset}
        onShowInfo={toggleInfo}
        onSetActiveItem={handleSetModel}
        onZoom={setZoom}
        onSetAutoRotate={toggleRotate}
      />
    </div>
  ) : null
}

export default TrilobiteViewerApp
